import type { Icon } from '@/components/icons'
import {
  Diamond,
  Flower,
  Gift,
  Package,
  Palette,
  Scissors,
  Scroll,
  ShoppingBag,
  Sparkle,
  Yarn,
} from '@/components/icons'
import type { CategoryIconKey } from '@/modules/products/domain/contracts'

export type CategoryIconOption = {
  key: CategoryIconKey
  label: string
  Icon: Icon
}

export const CATEGORY_ICON_OPTIONS: CategoryIconOption[] = [
  { key: 'yarn', label: 'ເຊືອກ / ໄໝ', Icon: Yarn },
  { key: 'scroll', label: 'ກະດາດ / ສຕິກເກອ', Icon: Scroll },
  { key: 'sparkle', label: 'ຕົບແຕ່ງ', Icon: Sparkle },
  { key: 'scissors', label: 'ເຄື່ອງມື', Icon: Scissors },
  { key: 'diamond', label: 'ລູກປະດັບ', Icon: Diamond },
  { key: 'gift', label: 'ກ່ອງ / ຂອງຂວັນ', Icon: Gift },
  { key: 'package', label: 'ສິນຄ້າທົ່ວໄປ', Icon: Package },
  { key: 'flower', label: 'ດອກໄມ້ / ແບຣນດ໌', Icon: Flower },
  { key: 'palette', label: 'ສີ / ສິລະປະ', Icon: Palette },
  { key: 'shopping_bag', label: 'ຊື້ເຂົ້າ', Icon: ShoppingBag },
]

const iconByKey = new Map(
  CATEGORY_ICON_OPTIONS.map((option) => [option.key, option.Icon]),
)

export function resolveCategoryIcon(
  iconKey: CategoryIconKey | string | null | undefined,
): Icon {
  if (iconKey && iconByKey.has(iconKey as CategoryIconKey)) {
    return iconByKey.get(iconKey as CategoryIconKey)!
  }
  return Package
}

export const DEFAULT_CATEGORY_ICON_KEY: CategoryIconKey = 'package'
